import {createSelector} from 'reselect';
import addressDefinitionsByCountry from '../components/address/address-definitions-by-country';
import {getSelectedDeliveryCountry} from './selectors';

export default createSelector(
  [getSelectedDeliveryCountry],
  country => country && addressDefinitionsByCountry.get(country),
);
